import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { styled } from '@mui/material/styles';

import { styleConfigs } from '../../../resources/styleConfigs';

export const ChangePasswordFormRootStyles = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const PatternPassIcon = styled(CheckCircleIcon)(({ theme }) => ({
  color: theme.palette.icons.greenTeal,
  marginLeft: styleConfigs.marginPadding.custom5,
}));

export const PatternNotPassIcon = styled(ErrorIcon)(({ theme }) => ({
  color: theme.palette.icons.coralRed,
  marginLeft: styleConfigs.marginPadding.custom5,
}));
